<footer id="footer">
	<div class="central-wrapper clearfix">
		<div class="footer_bottom clearfix">
			<ul class="menu_footer_movil">
				<li><a href="https://cp.com.pe/pacifico/aviso-de-privacidad/" target="_blank">Políticas de Seguridad</a></li>
				<li><a href="javascript:;" class="mostrar_legal">Legal</a></li>
				<li>
					<a href="https://cp.com.pe/pacifico/in/general/personas/promociones-personas/" target="_blank">Promociones</a>
				</li>
				<li><a href="https://cp.com.pe/pacifico/transparencia/" target="_blank">Transparencia</a></li>
				<li><a href="https://cp.com.pe/pacifico/tarifario/" target="_blank">Tarifario</a></li>
				<li><a href="https://cp.com.pe/pacifico/canales-de-contacto/" target="_blank">Contáctenos</a></li>
			</ul>
			<div class="copy_left">Cooperativa Pacífico © 2021 - Todos los derechos reservados.</div>
			<div class="develop_right">
				<a href="https://cp.com.pe/pacifico/aviso-de-privacidad/" target="_blank">Políticas de Seguridad</a>
			</div>
		</div>
	</div>
</footer>
